function loadSprite() {
  const spritePath = document.body.getAttribute('data-sprite') || '/assets/svg.svg?v2';

  const request = new XMLHttpRequest();
  request.open('GET', spritePath, true);

  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      // Success!
      const svg = document.createElement('div');
      svg.classList.add('svg-sprite');
      svg.innerHTML = request.responseText;
      document.body.appendChild(svg);
    }
  };

  request.send();
}

export default loadSprite;
